import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import {
  IDatatableOutputDTO,
  IDatatableParams,
} from 'src/app/shared/datatables/datatables';
import { HttpParamsMapper } from 'src/app/shared/mappers/http-params.mapper';
import { IndicationAnalytic } from '../contracts/indication-analytics';

@Injectable({
  providedIn: 'root',
})
export class AdministrativeIndicationAnalyticsV2Service {
  url = `${environment.api_v2}/v2/administrative/indication-analytics`;

  constructor(private readonly http: HttpClient) {}

  public search({
    filter,
    page,
    perPage,
  }: IDatatableParams): Observable<IDatatableOutputDTO<IndicationAnalytic>> {
    const params = HttpParamsMapper.toHttpParams({
      filter: JSON.stringify(filter),
      page: page,
      perPage: perPage,
    });

    return this.http.get<IDatatableOutputDTO<IndicationAnalytic>>(this.url, {
      params,
    });
  }
}
